/**
 * A Mexican CLABE: 18 digits (bank, city, account, check digit). The last digit is the remainder of the first
 * seventeen weighted 3-7-1, so a mistyped CLABE is caught before the transfer leaves instead of coming back.
 */
const CLABE_WEIGHTS = [3, 7, 1];

export const clabeDigits = (raw: string): string => raw.replace(/\D/g, "").slice(0, 18);

export function clabeCheckDigit(first17: string): number {
  let sum = 0;
  for (let i = 0; i < 17; i++) sum += (Number(first17[i]) * CLABE_WEIGHTS[i % 3]) % 10;
  return (10 - (sum % 10)) % 10;
}

export function isValidClabe(raw: string): boolean {
  const d = raw.replace(/\D/g, "");
  return d.length === 18 && clabeCheckDigit(d) === Number(d[17]);
}

/** Groups the CLABE as it is printed, bank · city · account · check: `032 180 00011835971 9`. */
export function formatClabe(raw: string): string {
  const d = clabeDigits(raw);
  return [d.slice(0, 3), d.slice(3, 6), d.slice(6, 17), d.slice(17)].filter(Boolean).join(" ");
}
